import axios from 'axios';
import envConfig from '../../config/env';

 const LoginCheck =  (cid) => {

    //let cid = props.match.params.cid;

    async function axiosGet() {      
      const postRes = await axios.post(`${envConfig.WebAPI}/Login`, {          
            oNo: cid,
            Link:`${envConfig.ManageURL}`+ cid
      });
      //console.log(postRes);
      return await postRes.data;

  }
  
  return axiosGet();
  /* axiosGet()
  .then((ApiLogined) => {
    console.log(ApiLogined.Logined);
      if(ApiLogined.Logined === 0) {
          console.log('axios get request over, and return valid to the sync code.');
          Logined = false;
      }
  })

  return Logined; */
} 

/* function LoginCheck(that) {
    constructor(props) {
        super(props);
        this.state = {isToggleOn: true};
    
        // 為了讓 `this` 能在 callback 中被使用，這裡的綁定是必要的：
        this.handleClick = this.handleClick.bind(this);
      }
    const cid = that.props.match.params.cid;

    console.log("cid="&cid);

    //this.props.checkLogin(cid, this);

    return false;
} */

export default LoginCheck;
